import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './HumanitiesMissionSection.module.css';

export function HumanitiesMissionSection() {
  return (
    <SectionWrapper background="soft" data-testid="humanities-section-mission">
      <div className={styles.section}>
        <p className={styles.lead}>
          The most important challenge facing higher education is not how to help
          students produce more content. It is how to help them become better
          thinkers, writers, researchers, and citizens in a world increasingly
          shaped by intelligent technologies.
        </p>

        <div className={styles.prose}>
          <p>
            Our work explores how AI can strengthen the core practices of the
            humanities: critical inquiry, interpretation, historical thinking,
            ethical reflection, close reading, and effective communication.
          </p>
          <p>
            Rather than replacing human learning, we design systems that expand
            access to mentorship, feedback, and personalized intellectual support.
            By combining faculty expertise, carefully designed pedagogies, and
            contextual AI, we create learning environments where students think
            more deeply and learn more effectively.
          </p>
        </div>
      </div>
    </SectionWrapper>
  );
}
